import styled from 'styled-components';
import { VerticalNavListMixin } from '../../mixins/components/VerticalNavListMixin';
export var StyledVerticalNavList = /*#__PURE__*/styled.ol.withConfig({
  displayName: "StyledVerticalNavList",
  componentId: "c11n-8-111-1__sc-1h79ar7-0"
})(["", ""], VerticalNavListMixin);